import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Autocomplete,
  FormControlLabel,
  InputAdornment,
  DialogContent,
  Dialog,
  RadioGroup,
  Radio,
  IconButton,
} from "@mui/material";
import { UseOffer } from "./UseOffer";
import SearchComOff from "./SearchComOff";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import CategoryAutoComplete from "../../../basic-information/productCategory/CategoryAutoComplete";
import BrandSearchCom from "../../../basic-information/brand/BrandSearchCom";
import SelectGroup from "./SelectGroup";
import { useSnackbar } from "notistack";
import EditIcon from "@mui/icons-material/Edit";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddProductOff(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, AddOfferProduct } = UseOffer();
  const [openDialog, setOpenDialog] = useState({
    show: false,
    modelID: undefined,
  });
  const [name, setName] = useState("");
  const [state, setState] = useState({
    OfferID: undefined,
    type: undefined,
    filter: undefined,
    brandID: undefined,
    categoryID: undefined,
    groupID: undefined,
    productID: undefined,
  });
  const [value, setValue] = useState("");
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.offers) {
      setValue(
        props.offers && props.offers.model !== null ? "onModel" : "onProduct"
      );
      setState({
        ...state,
        OfferID: props.offers.id,
      });
    }
    if (props.offers && props.offers.model) {
      if (props.offers.model.categoryID) {
        setName(props.offers.model.field);
        setState({
          OfferID: props.offers.model.offerID,
          type: props.offers.model.type,
          filter: 1,
          brandID: props.offers.model.brandID,
          categoryID: props.offers.model.categoryID,
          groupID: props.offers.model.groupID,
        });
      }
      if (props.offers.model.brandID) {
        setName(props.offers.model.field);
        setState({
          OfferID: props.offers.model.offerID,
          type: props.offers.model.type,
          filter: 2,
          brandID: props.offers.model.brandID,
          categoryID: props.offers.model.categoryID,
          groupID: props.offers.model.groupID,
        });
      }
      if (props.offers.model.groupID) {
        setName(props.offers.model.field);
        setState({
          OfferID: props.offers.model.offerID,
          type: props.offers.model.type,
          filter: 3,
          brandID: props.offers.model.brandID,
          categoryID: props.offers.model.categoryID,
          groupID: props.offers.model.groupID,
        });
      }
    }
  }, [props.offers]);

  const [errorState, setErrorState] = useState({
    type: false,
    filter: false,
    brandID: undefined,
    categoryID: undefined,
    groupID: undefined,
  });

  const list = [
    {
      id: 1,
      title: "بیشترین تخفیف",
    },
    {
      id: 2,
      title: "جدیدترین",
    },
    {
      id: 3,
      title: "پرفروش",
    },
    {
      id: 4,
      title: "محبوب ترین",
    },
    {
      id: 5,
      title: "رندوم",
    },
  ];

  const list2 = [
    { id: 1, title: "دسته" },
    { id: 2, title: "برند" },
    { id: 3, title: "گروه" },
  ];

  return (
    <Box>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth={openDialog.modelID == 3 ? "xl" : "sm"}
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          sx={{
            height: openDialog.modelID == 3 ? "auto" : "10rem",
            display: "flex",
            my: "auto",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {openDialog.modelID == 1 && (
            <CategoryAutoComplete
              setName={setName}
              validation={errorState.categoryID}
              selectedCategoryID={state.categoryID}
              setter={setState}
              lvl1State={state}
              Offer
            ></CategoryAutoComplete>
          )}
          {openDialog.modelID == 2 && (
            <BrandSearchCom
              setName={setName}
              validation={errorState.brandID}
              selectedBrandID={state.brandID}
              setter={setState}
              lvl1State={state}
              Offer
            ></BrandSearchCom>
          )}
          {openDialog.modelID == 3 && (
            <SelectGroup
              Offer
              setName={setName}
              validation={errorState.groupID}
              selectedGroupID={state.groupID && state.groupID}
              setter={setState}
              lvl1State={state}
            ></SelectGroup>
          )}
          <Button
            sx={{ mt: 2, width: "70px" }}
            variant="contained"
            onClick={() => {
              setOpenDialog({ ...openDialog, show: false });
            }}
          >
            ثبت
          </Button>
        </DialogContent>
      </Dialog>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value && value}
        onChange={(event) => {
          setState({
            ...state,
            type: undefined,
            filter: undefined,
            brandID: undefined,
            categoryID: undefined,
            groupID: undefined,
            productID: undefined,
          });
          setValue(event.target.value);
        }}
      >
        <Box
          sx={{ mb: 3 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={2}
        >
          <Box
            sx={{ display: "flex", justifyContent: "space-between" }}
            gridColumn="span 12"
          >
            <FormControlLabel
              value="onProduct"
              sx={{
                "&.MuiFormControlLabel-root .MuiFormControlLabel-label ": {
                  color: "secondary.main",
                },
              }}
              control={<Radio color="secondary" />}
              label="افزودن محصول"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span  8"}>
            <Box
              sx={{
                display: "flex",
                flexDirection: isSmall ? "column" : "row",
                alignItems: isSmall ? "flex-end" : "center",
                gap: 2,
              }}
            >
              <SearchComOff
                article={isSmall ? true : false}
                productID={state.productID}
                productModel={state}
                setProductModel={setState}
              />
              <Button
                sx={{ mr: 2, width: "100px" }}
                variant="contained"
                onClick={() => {
                  if (!props.offers.id) {
                    enqueueSnackbar("ابتدا اطلاعات فوق را ثبت کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  if (!state.productID) {
                    enqueueSnackbar("محصول مشخص نیست", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  AddOfferProduct(state, (calback) => {
                    setState({
                      ...state,
                      productID: undefined,
                    });
                    props.callback();
                  });
                }}
              >
                افزودن
              </Button>
            </Box>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span  4"}></Box>
          <Box sx={{ mt: 2 }} gridColumn="span 12">
            <FormControlLabel
              value="onModel"
              sx={{
                "&.MuiFormControlLabel-root .MuiFormControlLabel-label ": {
                  color: "secondary.main",
                },
              }}
              control={<Radio color="secondary" />}
              label="افزودن مدل محصولات"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <Autocomplete
              sx={{ mb: !isSmall && 5 }}
              size="small"
              value={state.type ? state.type : ""}
              onChange={(event, newValue) => {
                setState({ ...state, type: newValue, productID: undefined });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return (
                    list !== undefined && list.find((m) => m.id == option).title
                  );
                }
                return "";
              }}
              fullWidth
              options={list.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  error={errorState.type}
                  variant="outlined"
                  {...params}
                  label="بر اساس"
                />
              )}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <Autocomplete
              size="small"
              sx={{ mb: !isSmall && 5 }}
              value={state.filter ? state.filter : ""}
              onChange={(event, newValue) => {
                setState({
                  ...state,
                  filter: newValue,
                  brandID: undefined,
                  categoryID: undefined,
                  groupID: undefined,
                  productID: undefined,
                });
                if (newValue) {
                  setOpenDialog({ show: true, modelID: newValue });
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              getOptionLabel={(option) => {
                if (option) {
                  return (
                    list2 !== undefined &&
                    list2.find((m) => m.id == option).title
                  );
                }
                return "";
              }}
              fullWidth
              options={list2.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  error={errorState.filter}
                  variant="outlined"
                  {...params}
                  label="انتخاب از"
                />
              )}
            />
          </Box>
          {state.filter && (
            <Box gridColumn={isSmall ? "span 12" : "span  3"}>
              <TextField
                sx={{ width: "100%" }}
                value={name ? name : ""}
                size="small"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                  autoComplete: "off",
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          if (state.filter) {
                            setOpenDialog({
                              show: true,
                              modelID: state.filter,
                            });
                          }
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 5,
            }}
            gridColumn={isSmall ? "span 12" : "span  3"}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  AddOfferProduct(state, (calback) => {
                    props.callback();
                  });
                }
              }}
            >
              افزودن
            </Button>
          </Box>
        </Box>
      </RadioGroup>
    </Box>
  );
}
